import { put, call, select, takeLeading } from 'redux-saga/effects';

import * as $app from 'modules/app';
import * as api from '../api';
import * as actions from '../actions';
import * as selectors from '../selectors';

const publishProfile = function* ({ payload }) {
  const { callbacks } = payload;

  try {
    const token = yield select(selectors.getToken);
    const publisherID = yield select(selectors.getSelectedPublisherId);
    const userCustomFields = yield call(api.publishProfile, { token, publisherID });

    yield put(actions.setCurrentUserCustomFields(userCustomFields));
    yield put($app.updateOnboardingSteps());

    callbacks.onSuccess();
  } catch {
    callbacks.onError();
  }
};

export const publishProfileSaga = function* () {
  yield takeLeading(actions.publishProfile, publishProfile);
};
